import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function Assignee({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M23.61 24.0012C28.5808 24.0012 32.6105 19.9715 32.6105 15.0006C32.6105 10.0297 28.5808 6 23.61 6C18.6391 6 14.6094 10.0297 14.6094 15.0006C14.6094 19.9715 18.6391 24.0012 23.61 24.0012Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.0004 41.998C41.4825 38.4565 40.0336 35.1161 37.8015 32.3182C35.5693 29.5203 32.6341 27.3654 29.2961 26.0737C29.2511 26.0985 29.2038 26.1097 29.17 26.1322C28.8618 26.292 28.5401 26.4293 28.2183 26.5688C28.126 26.6025 28.0339 26.6386 27.9304 26.6723C27.5502 26.8163 27.1609 26.9355 26.7694 27.0413H26.7468C26.3532 27.139 25.9542 27.2141 25.552 27.2663L25.2413 27.3001C24.8223 27.3492 24.4011 27.3755 23.9792 27.3789C23.5491 27.3755 23.1194 27.3492 22.6921 27.3001C22.5863 27.2888 22.4759 27.2663 22.3611 27.2528C22.0348 27.2078 21.6929 27.1493 21.3599 27.0705C21.2811 27.0458 21.189 27.0345 21.108 27.012C20.2853 26.7981 19.4879 26.4964 18.7296 26.112L18.662 26.0783C17.9613 26.3349 17.2771 26.6338 16.6133 26.9731"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 35.2788H19.5009"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M13.2598 28.5015L19.0876 34.3293C19.3522 34.595 19.5007 34.9546 19.5007 35.3295C19.5007 35.7044 19.3522 36.0641 19.0876 36.3297L13.4195 42.0023"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </SvgIconComponent>
  )
}

export function ContactEnclosed({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="42"
      width="43"
      fill="none"
      viewBox="0 0 43 42"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M21.4 41C32.4457 41 41.4 32.0457 41.4 21C41.4 9.9543 32.4457 1 21.4 1C10.3543 1 1.39999 9.9543 1.39999 21C1.39999 32.0457 10.3543 41 21.4 41Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth="2"
      />
      <path
        d="M22.1129 18.5C23.4936 18.5 24.6129 17.3807 24.6129 16C24.6129 14.6193 23.4936 13.5 22.1129 13.5C20.7322 13.5 19.6129 14.6193 19.6129 16C19.6129 17.3807 20.7322 18.5 22.1129 18.5Z"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M17.1125 26.7166C17.0441 25.5363 17.3511 24.3647 17.9894 23.3695C18.6277 22.3744 19.5647 21.6068 20.666 21.1767H20.6859C20.892 21.2818 21.1087 21.3646 21.3325 21.4233H21.4024C21.4924 21.4433 21.5826 21.46 21.6759 21.4733H21.7658C21.882 21.4862 21.9988 21.4929 22.1157 21.4933C22.2271 21.4926 22.3383 21.4858 22.449 21.4733H22.5324C22.6447 21.4587 22.7559 21.4376 22.8657 21.41C22.9723 21.38 23.0793 21.3466 23.1826 21.3099L23.2591 21.2833C23.3458 21.2466 23.4358 21.2067 23.5191 21.1633H23.5525C24.6538 21.5934 25.5908 22.3611 26.2291 23.3562C26.8674 24.3514 27.1743 25.523 27.106 26.7033"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M29.4967 9.56995H14.7333C12.8924 9.56995 11.4 11.0623 11.4 12.9033V29.0933C11.4 30.9342 12.8924 32.4266 14.7333 32.4266H29.4967C31.3376 32.4266 32.83 30.9342 32.83 29.0933V12.9033C32.83 11.0623 31.3376 9.56995 29.4967 9.56995Z"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M9.97031 21H12.827"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M9.97031 13.8564H12.827"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        d="M9.97031 28.1436H12.827"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeWidth="2"
      />
    </SvgIconComponent>
  )
}
export function ContactPlain({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      {...props}
      size={size}
    >
      <path
        d="M25.1265 21.753C27.3019 21.753 29.0655 19.9894 29.0655 17.814C29.0655 15.6386 27.3019 13.875 25.1265 13.875C22.9511 13.875 21.1875 15.6386 21.1875 17.814C21.1875 19.9894 22.9511 21.753 25.1265 21.753Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2489 33.0001C17.1421 31.1413 17.6262 29.2963 18.6317 27.7293C19.6372 26.1623 21.1126 24.9536 22.8468 24.2761H22.8768C23.2018 24.4424 23.5441 24.5732 23.8971 24.6661L24.0048 24.6901C24.1488 24.7231 24.305 24.7501 24.434 24.7681L24.5749 24.7891C24.7582 24.8099 24.9424 24.821 25.1268 24.8221C25.3073 24.8209 25.4877 24.8099 25.667 24.7891H25.7988C25.9716 24.7659 26.1429 24.7329 26.3119 24.6901C26.4799 24.6451 26.6479 24.5911 26.8099 24.5311L26.933 24.4861C27.071 24.4261 27.2089 24.3691 27.3409 24.3001C27.3585 24.2912 27.3764 24.2832 27.3948 24.2761C29.1293 24.9532 30.605 26.1618 31.6106 27.7289C32.6162 29.296 33.1002 31.1412 32.993 33.0001"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 6H14.25C10.9363 6 8.25 8.68629 8.25 12V36C8.25 39.3137 10.9363 42 14.25 42H36C39.3137 42 42 39.3137 42 36V12C42 8.68629 39.3137 6 36 6Z"
        stroke="inherit"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 24H10.5"
        stroke="inherit"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M6 12.75H10.5"
        stroke="inherit"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M6 35.25H10.5"
        stroke="inherit"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </SvgIconComponent>
  )
}

export function Mail({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M41.3333 8H6.66667C5.19391 8 4 9.19391 4 10.6667V37.3333C4 38.8061 5.19391 40 6.66667 40H41.3333C42.8061 40 44 38.8061 44 37.3333V10.6667C44 9.19391 42.8061 8 41.3333 8Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.3789 24L40.0002 33.6213"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 33.6213L17.6213 24"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14.3787L17.6213 24"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6211 24L22.5864 28.9653C22.9622 29.3394 23.4709 29.5494 24.0011 29.5494C24.5313 29.5494 25.04 29.3394 25.4158 28.9653L30.3784 24"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.0002 14.3784L30.3789 23.9998"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function MemberPlainDefault({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      {...props}
      size={size}
    >
      <path
        d="M23.6059 23.9969C28.5756 23.9969 32.6043 19.9681 32.6043 14.9984C32.6043 10.0287 28.5756 6 23.6059 6C18.6362 6 14.6074 10.0287 14.6074 14.9984C14.6074 19.9681 18.6362 23.9969 23.6059 23.9969Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99982 41.7477C6.49764 38.235 7.93772 34.9228 10.1669 32.1628C12.3962 29.4028 15.3315 27.2982 18.6608 26.0724L18.7297 26.1054C19.487 26.4895 20.2834 26.7912 21.1052 27.0053C21.1862 27.0293 21.2795 27.0382 21.3575 27.0622C21.6905 27.1402 22.0231 27.2002 22.356 27.2452C22.47 27.2452 22.5752 27.2812 22.6892 27.2932C23.1164 27.343 23.5458 27.3701 23.9758 27.3742C24.3979 27.3701 24.8195 27.343 25.2387 27.2932L25.5386 27.2602C25.9425 27.2072 26.3432 27.1312 26.7384 27.0323H26.7593C27.1492 26.9273 27.5394 26.8013 27.9203 26.6633L28.2202 26.5613C28.5412 26.4234 28.8651 26.2854 29.174 26.1234C29.207 26.0994 29.255 26.0904 29.3 26.0664C32.6369 27.3582 35.571 29.5128 37.8023 32.3101C40.0336 35.1074 41.4821 38.4471 41.9998 41.9877"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function MemberPlainInvited({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M23.604 23.4293C28.5737 23.4293 32.6025 19.4005 32.6025 14.4308C32.6025 9.46111 28.5737 5.43237 23.604 5.43237C18.6343 5.43237 14.6056 9.46111 14.6056 14.4308C14.6056 19.4005 18.6343 23.4293 23.604 23.4293Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 41.1796C6.49783 37.6669 7.93791 34.3546 10.1671 31.5946C12.3963 28.8347 15.3317 26.73 18.661 25.5043L18.7299 25.5373C19.4872 25.9214 20.2836 26.2231 21.1054 26.4372C21.1864 26.4612 21.2797 26.4701 21.3577 26.4941C21.6906 26.5721 22.0232 26.6321 22.3562 26.6771C22.4702 26.6771 22.5754 26.7131 22.6894 26.7251C23.1166 26.7749 23.546 26.802 23.976 26.8061C24.3981 26.802 24.8197 26.7749 25.2389 26.7251L25.5387 26.6921C25.9427 26.6391 26.3434 26.563 26.7386 26.4642H26.7595C27.1494 26.3592 27.5396 26.2332 27.9205 26.0952L28.2204 25.9932C28.5413 25.8553 28.8653 25.7173 29.1742 25.5553C29.2072 25.5313 29.2552 25.5223 29.3002 25.4983C30.6005 26.0017 31.8397 26.6361 33 27.3885"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#4D8CE8"
      />
    </SvgIconComponent>
  )
}
export function MemberPlainActive({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#141A21"
      {...props}
      size={size}
    >
      <path
        d="M23.604 23.4293C28.5737 23.4293 32.6025 19.4005 32.6025 14.4308C32.6025 9.46111 28.5737 5.43237 23.604 5.43237C18.6343 5.43237 14.6056 9.46111 14.6056 14.4308C14.6056 19.4005 18.6343 23.4293 23.604 23.4293Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 41.1796C6.49783 37.6669 7.93791 34.3546 10.1671 31.5946C12.3963 28.8347 15.3317 26.73 18.661 25.5043L18.7299 25.5373C19.4872 25.9214 20.2836 26.2231 21.1054 26.4372C21.1864 26.4612 21.2797 26.4701 21.3577 26.4941C21.6906 26.5721 22.0232 26.6321 22.3562 26.6771C22.4702 26.6771 22.5754 26.7131 22.6894 26.7251C23.1166 26.7749 23.546 26.802 23.976 26.8061C24.3981 26.802 24.8197 26.7749 25.2389 26.7251L25.5387 26.6921C25.9427 26.6391 26.3434 26.563 26.7386 26.4642H26.7595C27.1494 26.3592 27.5396 26.2332 27.9205 26.0952L28.2204 25.9932C28.5413 25.8553 28.8653 25.7173 29.1742 25.5553C29.2072 25.5313 29.2552 25.5223 29.3002 25.4983C30.6005 26.0017 31.8397 26.6361 33 27.3885"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#91D656"
      />
    </SvgIconComponent>
  )
}
export function MemberPlainError({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M23.604 23.4293C28.5737 23.4293 32.6025 19.4005 32.6025 14.4308C32.6025 9.46111 28.5737 5.43237 23.604 5.43237C18.6343 5.43237 14.6056 9.46111 14.6056 14.4308C14.6056 19.4005 18.6343 23.4293 23.604 23.4293Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 41.1796C6.49783 37.6669 7.93791 34.3546 10.1671 31.5946C12.3963 28.8347 15.3317 26.73 18.661 25.5043L18.7299 25.5373C19.4872 25.9214 20.2836 26.2231 21.1054 26.4372C21.1864 26.4612 21.2797 26.4701 21.3577 26.4941C21.6906 26.5721 22.0232 26.6321 22.3562 26.6771C22.4702 26.6771 22.5754 26.7131 22.6894 26.7251C23.1166 26.7749 23.546 26.802 23.976 26.8061C24.3981 26.802 24.8197 26.7749 25.2389 26.7251L25.5387 26.6921C25.9427 26.6391 26.3434 26.563 26.7386 26.4642H26.7595C27.1494 26.3592 27.5396 26.2332 27.9205 26.0952L28.2204 25.9932C28.5413 25.8553 28.8653 25.7173 29.1742 25.5553C29.2072 25.5313 29.2552 25.5223 29.3002 25.4983C30.6005 26.0017 31.8397 26.6361 33 27.3885"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#EA4444"
      />
    </SvgIconComponent>
  )
}

export function MemberPlainInactive({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#141A21"
      {...props}
      size={size}
    >
      <path
        d="M23.604 23.4293C28.5737 23.4293 32.6025 19.4005 32.6025 14.4308C32.6025 9.46111 28.5737 5.43237 23.604 5.43237C18.6343 5.43237 14.6056 9.46111 14.6056 14.4308C14.6056 19.4005 18.6343 23.4293 23.604 23.4293Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 41.1796C6.49783 37.6669 7.93791 34.3546 10.1671 31.5946C12.3963 28.8347 15.3317 26.73 18.661 25.5043L18.7299 25.5373C19.4872 25.9214 20.2836 26.2231 21.1054 26.4372C21.1864 26.4612 21.2797 26.4701 21.3577 26.4941C21.6906 26.5721 22.0232 26.6321 22.3562 26.6771C22.4702 26.6771 22.5754 26.7131 22.6894 26.7251C23.1166 26.7749 23.546 26.802 23.976 26.8061C24.3981 26.802 24.8197 26.7749 25.2389 26.7251L25.5387 26.6921C25.9427 26.6391 26.3434 26.563 26.7386 26.4642H26.7595C27.1494 26.3592 27.5396 26.2332 27.9205 26.0952L28.2204 25.9932C28.5413 25.8553 28.8653 25.7173 29.1742 25.5553C29.2072 25.5313 29.2552 25.5223 29.3002 25.4983C30.6005 26.0017 31.8397 26.6361 33 27.3885"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#BEBEC7"
      />
    </SvgIconComponent>
  )
}

export function MemberPlainCutout({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M23.604 23.4293C28.5737 23.4293 32.6025 19.4005 32.6025 14.4308C32.6025 9.46111 28.5737 5.43237 23.604 5.43237C18.6343 5.43237 14.6056 9.46111 14.6056 14.4308C14.6056 19.4005 18.6343 23.4293 23.604 23.4293Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 41.1796C6.49783 37.6669 7.93791 34.3546 10.1671 31.5946C12.3963 28.8347 15.3317 26.73 18.661 25.5043L18.7299 25.5373C19.4872 25.9214 20.2836 26.2231 21.1054 26.4372C21.1864 26.4612 21.2797 26.4701 21.3577 26.4941C21.6906 26.5721 22.0232 26.6321 22.3562 26.6771C22.4702 26.6771 22.5754 26.7131 22.6894 26.7251C23.1166 26.7749 23.546 26.802 23.976 26.8061C24.3981 26.802 24.8197 26.7749 25.2389 26.7251L25.5387 26.6921C25.9427 26.6391 26.3434 26.563 26.7386 26.4642H26.7595C27.1494 26.3592 27.5396 26.2332 27.9205 26.0952L28.2204 25.9932C28.5413 25.8553 28.8653 25.7173 29.1742 25.5553C29.2072 25.5313 29.2552 25.5223 29.3002 25.4983C30.6005 26.0017 31.8397 26.6361 33 27.3885"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function MemberEnclosedDefault({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="42"
      width="43"
      fill="none"
      viewBox="0 0 43 42"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M21.4019 41.0005C32.4476 41.0005 41.4019 32.0462 41.4019 21.0005C41.4019 9.95479 32.4476 1.00049 21.4019 1.00049C10.3562 1.00049 1.40192 9.95479 1.40192 21.0005C1.40192 32.0462 10.3562 41.0005 21.4019 41.0005Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth="2"
      />
      <path
        d="M21.1543 19.9272C24.3097 19.9272 26.8676 17.3692 26.8676 14.2138C26.8676 11.0584 24.3097 8.50049 21.1543 8.50049C17.9989 8.50049 15.441 11.0584 15.441 14.2138C15.441 17.3692 17.9989 19.9272 21.1543 19.9272Z"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M9.97412 32.2731C10.2905 30.0427 11.2054 27.9395 12.621 26.187C14.0366 24.4345 15.9004 23.0982 18.0145 22.3198L18.0576 22.3431C18.5388 22.5889 19.0451 22.7823 19.5676 22.9198C19.621 22.9198 19.6775 22.9431 19.7275 22.9564C19.9409 23.0064 20.151 23.0431 20.3643 23.0731C20.4377 23.0731 20.5043 23.0964 20.5743 23.1031C20.8454 23.1343 21.118 23.151 21.391 23.1532C21.6594 23.151 21.9275 23.1343 22.1942 23.1031L22.3911 23.0798C22.647 23.0455 22.9005 22.9965 23.1508 22.9331C23.4008 22.8665 23.6477 22.7864 23.8877 22.6998L24.0708 22.6331C24.2741 22.5465 24.4809 22.4565 24.6742 22.3565C24.7003 22.3429 24.7271 22.3307 24.7544 22.3198C26.8739 23.1396 28.7375 24.5076 30.1548 26.284C31.5721 28.0603 32.492 30.1812 32.8208 32.4298"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </SvgIconComponent>
  )
}

export function MemberEnclosedInvited({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00195 24.0005C5.00195 13.5071 13.5085 5.00049 24.002 5.00049C34.4954 5.00049 43.002 13.5071 43.002 24.0005C43.002 26.4962 42.5208 28.8796 41.6461 31.0628C42.1766 31.669 42.611 32.3614 42.9257 33.1162C44.2562 30.3591 45.002 27.2669 45.002 24.0005C45.002 12.4025 35.5999 3.00049 24.002 3.00049C12.404 3.00049 3.00195 12.4025 3.00195 24.0005C3.00195 35.5985 12.404 45.0005 24.002 45.0005C27.2676 45.0005 30.3592 44.2551 33.1158 42.9251C32.361 42.6104 31.6687 42.1759 31.0625 41.6453C28.8798 42.5196 26.497 43.0005 24.002 43.0005C13.5085 43.0005 5.00195 34.4939 5.00195 24.0005Z"
        fill="#141A21"
      />
      <path
        d="M23.7543 22.9272C26.9097 22.9272 29.4677 20.3692 29.4677 17.2138C29.4677 14.0584 26.9097 11.5005 23.7543 11.5005C20.599 11.5005 18.041 14.0584 18.041 17.2138C18.041 20.3692 20.599 22.9272 23.7543 22.9272Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.574 35.2731C12.8904 33.0427 13.8053 30.9395 15.2209 29.187C16.6365 27.4345 18.5003 26.0982 20.6144 25.3198L20.6575 25.3431C21.1387 25.5889 21.645 25.7823 22.1675 25.9198C22.2209 25.9198 22.2775 25.9431 22.3275 25.9564C22.5408 26.0064 22.7509 26.0431 22.9643 26.0731C23.0376 26.0731 23.1042 26.0964 23.1742 26.1031C23.4454 26.1342 23.7179 26.151 23.9909 26.1532C24.2593 26.151 24.5274 26.1343 24.7941 26.1031L24.991 26.0798C25.247 26.0455 25.5004 25.9965 25.7507 25.9331C26.0007 25.8665 26.2476 25.7864 26.4876 25.6998L26.6707 25.6331C26.874 25.5465 27.0808 25.4564 27.2741 25.3564C27.3002 25.3429 27.327 25.3307 27.3543 25.3198C28.9727 25.9458 30.4419 26.8914 31.6771 28.0944"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#4D8CE8"
      />
    </SvgIconComponent>
  )
}

export function MemberEnclosedActive({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00195 24.0005C5.00195 13.5071 13.5085 5.00049 24.002 5.00049C34.4954 5.00049 43.002 13.5071 43.002 24.0005C43.002 26.4962 42.5208 28.8796 41.6461 31.0628C42.1766 31.669 42.611 32.3614 42.9257 33.1162C44.2562 30.3591 45.002 27.2669 45.002 24.0005C45.002 12.4025 35.5999 3.00049 24.002 3.00049C12.404 3.00049 3.00195 12.4025 3.00195 24.0005C3.00195 35.5985 12.404 45.0005 24.002 45.0005C27.2676 45.0005 30.3592 44.2551 33.1158 42.9251C32.361 42.6104 31.6687 42.1759 31.0625 41.6453C28.8798 42.5196 26.497 43.0005 24.002 43.0005C13.5085 43.0005 5.00195 34.4939 5.00195 24.0005Z"
        fill={stroke ?? '#141A21'}
      />
      <path
        d="M23.7543 22.9272C26.9097 22.9272 29.4677 20.3692 29.4677 17.2138C29.4677 14.0584 26.9097 11.5005 23.7543 11.5005C20.5989 11.5005 18.041 14.0584 18.041 17.2138C18.041 20.3692 20.5989 22.9272 23.7543 22.9272Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.574 35.2731C12.8904 33.0427 13.8053 30.9395 15.2209 29.187C16.6365 27.4345 18.5003 26.0982 20.6144 25.3198L20.6575 25.3431C21.1387 25.5889 21.645 25.7823 22.1675 25.9198C22.2209 25.9198 22.2775 25.9431 22.3275 25.9564C22.5408 26.0064 22.7509 26.0431 22.9643 26.0731C23.0376 26.0731 23.1042 26.0964 23.1742 26.1031C23.4454 26.1342 23.7179 26.151 23.9909 26.1532C24.2593 26.151 24.5274 26.1343 24.7941 26.1031L24.991 26.0798C25.247 26.0455 25.5004 25.9965 25.7507 25.9331C26.0007 25.8665 26.2476 25.7864 26.4876 25.6998L26.6707 25.6331C26.874 25.5465 27.0808 25.4564 27.2741 25.3564C27.3002 25.3429 27.327 25.3307 27.3543 25.3198C28.9727 25.9458 30.4419 26.8914 31.6771 28.0944"
        stroke={stroke ?? '#141A21'}
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#91D656"
      />
    </SvgIconComponent>
  )
}

export function MemberEnclosedError({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00195 24.0005C5.00195 13.5071 13.5085 5.00049 24.002 5.00049C34.4954 5.00049 43.002 13.5071 43.002 24.0005C43.002 26.4962 42.5208 28.8796 41.6461 31.0628C42.1766 31.669 42.611 32.3614 42.9257 33.1162C44.2562 30.3591 45.002 27.2669 45.002 24.0005C45.002 12.4025 35.5999 3.00049 24.002 3.00049C12.404 3.00049 3.00195 12.4025 3.00195 24.0005C3.00195 35.5985 12.404 45.0005 24.002 45.0005C27.2676 45.0005 30.3592 44.2551 33.1158 42.9251C32.361 42.6104 31.6687 42.1759 31.0625 41.6453C28.8798 42.5196 26.497 43.0005 24.002 43.0005C13.5085 43.0005 5.00195 34.4939 5.00195 24.0005Z"
        fill="#141A21"
      />
      <path
        d="M23.7543 22.9272C26.9097 22.9272 29.4677 20.3692 29.4677 17.2138C29.4677 14.0584 26.9097 11.5005 23.7543 11.5005C20.599 11.5005 18.041 14.0584 18.041 17.2138C18.041 20.3692 20.599 22.9272 23.7543 22.9272Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5741 35.2731C12.8904 33.0427 13.8053 30.9395 15.2209 29.187C16.6365 27.4345 18.5004 26.0982 20.6144 25.3198L20.6575 25.3431C21.1388 25.5889 21.645 25.7823 22.1676 25.9198C22.2209 25.9198 22.2775 25.9431 22.3275 25.9564C22.5408 26.0064 22.7509 26.0431 22.9643 26.0731C23.0376 26.0731 23.1042 26.0964 23.1742 26.1031C23.4454 26.1342 23.718 26.151 23.9909 26.1532C24.2594 26.151 24.5274 26.1343 24.7941 26.1031L24.991 26.0798C25.247 26.0455 25.5004 25.9965 25.7507 25.9331C26.0007 25.8665 26.2476 25.7864 26.4876 25.6998L26.6707 25.6331C26.8741 25.5465 27.0808 25.4564 27.2742 25.3564C27.3002 25.3429 27.3271 25.3307 27.3543 25.3198C28.9727 25.9458 30.4419 26.8914 31.6772 28.0944"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#EA4444"
      />
    </SvgIconComponent>
  )
}

export function MemberEnclosedInactive({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00195 24.0005C5.00195 13.5071 13.5085 5.00049 24.002 5.00049C34.4954 5.00049 43.002 13.5071 43.002 24.0005C43.002 26.4962 42.5208 28.8796 41.6461 31.0628C42.1766 31.669 42.611 32.3614 42.9257 33.1162C44.2562 30.3591 45.002 27.2669 45.002 24.0005C45.002 12.4025 35.5999 3.00049 24.002 3.00049C12.404 3.00049 3.00195 12.4025 3.00195 24.0005C3.00195 35.5985 12.404 45.0005 24.002 45.0005C27.2676 45.0005 30.3592 44.2551 33.1158 42.9251C32.361 42.6104 31.6687 42.1759 31.0625 41.6453C28.8798 42.5196 26.497 43.0005 24.002 43.0005C13.5085 43.0005 5.00195 34.4939 5.00195 24.0005Z"
        fill="#141A21"
      />
      <path
        d="M23.7543 22.9272C26.9097 22.9272 29.4677 20.3692 29.4677 17.2138C29.4677 14.0584 26.9097 11.5005 23.7543 11.5005C20.599 11.5005 18.041 14.0584 18.041 17.2138C18.041 20.3692 20.599 22.9272 23.7543 22.9272Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.574 35.2731C12.8904 33.0427 13.8053 30.9395 15.2209 29.187C16.6365 27.4345 18.5004 26.0982 20.6144 25.3198L20.6575 25.3431C21.1387 25.5889 21.645 25.7823 22.1676 25.9198C22.2209 25.9198 22.2775 25.9431 22.3275 25.9564C22.5408 26.0064 22.7509 26.0431 22.9643 26.0731C23.0376 26.0731 23.1042 26.0964 23.1742 26.1031C23.4454 26.1342 23.718 26.151 23.9909 26.1532C24.2594 26.151 24.5274 26.1343 24.7941 26.1031L24.991 26.0798C25.247 26.0455 25.5004 25.9965 25.7507 25.9331C26.0007 25.8665 26.2476 25.7864 26.4876 25.6998L26.6707 25.6331C26.8741 25.5465 27.0808 25.4564 27.2742 25.3564C27.3002 25.3429 27.3271 25.3307 27.3543 25.3198C28.9727 25.9458 30.4419 26.8914 31.6772 28.0944"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#BEBEC7"
      />
    </SvgIconComponent>
  )
}

export function MemberEnclosedCutout({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00195 24.0005C5.00195 13.5071 13.5085 5.00049 24.002 5.00049C34.4954 5.00049 43.002 13.5071 43.002 24.0005C43.002 26.4962 42.5208 28.8796 41.6461 31.0628C42.1766 31.669 42.611 32.3614 42.9257 33.1162C44.2562 30.3591 45.002 27.2669 45.002 24.0005C45.002 12.4025 35.5999 3.00049 24.002 3.00049C12.404 3.00049 3.00195 12.4025 3.00195 24.0005C3.00195 35.5985 12.404 45.0005 24.002 45.0005C27.2676 45.0005 30.3592 44.2551 33.1158 42.9251C32.361 42.6104 31.6687 42.1759 31.0625 41.6453C28.8798 42.5196 26.497 43.0005 24.002 43.0005C13.5085 43.0005 5.00195 34.4939 5.00195 24.0005Z"
        fill="#141A21"
      />
      <path
        d="M23.7543 22.9272C26.9097 22.9272 29.4677 20.3692 29.4677 17.2138C29.4677 14.0584 26.9097 11.5005 23.7543 11.5005C20.599 11.5005 18.041 14.0584 18.041 17.2138C18.041 20.3692 20.599 22.9272 23.7543 22.9272Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5741 35.2731C12.8904 33.0427 13.8053 30.9395 15.2209 29.187C16.6365 27.4345 18.5004 26.0982 20.6144 25.3198L20.6575 25.3431C21.1388 25.5889 21.645 25.7823 22.1676 25.9198C22.2209 25.9198 22.2775 25.9431 22.3275 25.9564C22.5408 26.0064 22.7509 26.0431 22.9643 26.0731C23.0376 26.0731 23.1042 26.0964 23.1742 26.1031C23.4454 26.1342 23.718 26.151 23.9909 26.1532C24.2594 26.151 24.5274 26.1343 24.7941 26.1031L24.991 26.0798C25.247 26.0455 25.5004 25.9965 25.7507 25.9331C26.0007 25.8665 26.2476 25.7864 26.4876 25.6998L26.6707 25.6331C26.8741 25.5465 27.0808 25.4564 27.2742 25.3564C27.3002 25.3429 27.3271 25.3307 27.3543 25.3198C28.9727 25.9458 30.4419 26.8914 31.6772 28.0944"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Phone({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M17.8435 15.2429C17.2141 12.7761 16.4213 10.3537 15.4705 7.99199C15.3059 7.46834 14.9951 7.00263 14.5747 6.64971C14.1543 6.2968 13.6418 6.07137 13.0975 6C4.96758 6.336 4.56859 17.2439 8.16257 22.6019C12.7195 29.8769 24.3625 42.6298 33.5724 41.9758C35.5939 42.1001 37.5869 41.4506 39.1469 40.1592C40.707 38.8677 41.7171 37.0309 41.9724 35.0218C41.9931 34.3912 41.8074 33.7711 41.4435 33.2556C41.0796 32.7402 40.5575 32.3575 39.9564 32.1659C37.9794 31.5239 36.0084 30.8579 34.0374 30.1919C30.6234 28.6919 29.7894 33.5398 27.2365 32.7868C22.9163 31.0792 19.2703 28.0103 16.8505 24.0449C16.2145 22.5449 14.2075 20.6909 15.4915 19.1069C16.3405 17.9519 17.7535 16.9739 17.8165 15.4319C17.8165 15.3509 17.7895 15.2519 17.9215 15.2459"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.8644 25.7187C40.4961 23.2132 40.4591 20.5859 39.7572 18.0992C39.0553 15.6125 37.713 13.3536 35.8645 11.5482C34.016 9.74279 31.726 8.45419 29.2235 7.81116C26.7209 7.16812 24.0934 7.19317 21.6035 7.8838"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.2365 24.546C36.6742 22.7316 36.6343 20.8348 36.1205 19.0405C35.6067 17.2462 34.6368 15.6156 33.3051 14.3079C31.9735 13.0001 30.3257 12.0597 28.5224 11.5785C26.719 11.0973 24.8218 11.0916 23.0156 11.5621"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.5589 23.745C32.8428 22.5662 32.8183 21.3343 32.4878 20.1678C32.1573 19.0013 31.5318 17.9396 30.6718 17.085C29.8118 16.2304 28.7462 15.6117 27.5776 15.2885C26.409 14.9654 25.1769 14.9487 24 15.24"
        stroke="#141A21"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function RoleAdministrator({ size, ...props }) {
  return (
    <SvgIconComponent
      size={size}
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.9373 22.2671C18.46 22.2671 22.937 17.79 22.937 12.2673C22.937 6.74462 18.46 2.26758 12.9373 2.26758C7.41454 2.26758 2.9375 6.74462 2.9375 12.2673C2.9375 17.79 7.41454 22.2671 12.9373 22.2671Z"
        fill="#F4DFEE"
      />
      <path
        d="M9.60187 8.87758H10.6999L13.1299 15.2676H11.8519L11.2579 13.6746H9.02587L8.44087 15.2676H7.16287L9.60187 8.87758ZM11.0329 12.8016L10.1509 10.2906L9.23287 12.8016H11.0329ZM13.9807 15.2676V8.87758H16.3027C16.8247 8.87758 17.2807 8.96158 17.6707 9.12958C18.0667 9.29758 18.3967 9.52558 18.6607 9.81358C18.9247 10.1016 19.1227 10.4406 19.2547 10.8306C19.3867 11.2146 19.4527 11.6256 19.4527 12.0636C19.4527 12.5496 19.3777 12.9906 19.2277 13.3866C19.0837 13.7766 18.8737 14.1126 18.5977 14.3946C18.3217 14.6706 17.9887 14.8866 17.5987 15.0426C17.2147 15.1926 16.7827 15.2676 16.3027 15.2676H13.9807ZM18.2017 12.0636C18.2017 11.7576 18.1597 11.4756 18.0757 11.2176C17.9917 10.9596 17.8687 10.7376 17.7067 10.5516C17.5447 10.3656 17.3437 10.2216 17.1037 10.1196C16.8697 10.0176 16.6027 9.96658 16.3027 9.96658H15.2227V14.1786H16.3027C16.6087 14.1786 16.8787 14.1246 17.1127 14.0166C17.3527 13.9086 17.5507 13.7616 17.7067 13.5756C17.8687 13.3836 17.9917 13.1586 18.0757 12.9006C18.1597 12.6426 18.2017 12.3636 18.2017 12.0636Z"
        fill="#B758A1"
      />
    </SvgIconComponent>
  )
}

export function RoleCotributor({ size, ...props }) {
  return (
    <SvgIconComponent
      size={size}
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.8123 22.2671C18.335 22.2671 22.812 17.79 22.812 12.2673C22.812 6.74462 18.335 2.26758 12.8123 2.26758C7.28954 2.26758 2.8125 6.74462 2.8125 12.2673C2.8125 17.79 7.28954 22.2671 12.8123 22.2671Z"
        fill="#D4DEEF"
      />
      <path
        d="M6.56093 12.0276C6.56093 11.6376 6.62993 11.2536 6.76793 10.8756C6.91193 10.4916 7.11893 10.1496 7.38893 9.84958C7.65893 9.54958 7.98893 9.30658 8.37893 9.12058C8.76893 8.93458 9.21293 8.84158 9.71093 8.84158C10.2989 8.84158 10.8059 8.97058 11.2319 9.22858C11.6639 9.48658 11.9849 9.82258 12.1949 10.2366L11.2409 10.8936C11.1569 10.7136 11.0549 10.5636 10.9349 10.4436C10.8149 10.3176 10.6859 10.2186 10.5479 10.1466C10.4099 10.0746 10.2659 10.0236 10.1159 9.99358C9.96593 9.95758 9.81893 9.93958 9.67493 9.93958C9.36293 9.93958 9.08993 10.0026 8.85593 10.1286C8.62793 10.2546 8.43593 10.4196 8.27993 10.6236C8.12993 10.8216 8.01593 11.0496 7.93793 11.3076C7.85993 11.5596 7.82093 11.8116 7.82093 12.0636C7.82093 12.3456 7.86593 12.6186 7.95593 12.8826C8.04593 13.1406 8.17193 13.3686 8.33393 13.5666C8.50193 13.7646 8.69993 13.9236 8.92793 14.0436C9.16193 14.1636 9.41693 14.2236 9.69293 14.2236C9.83693 14.2236 9.98693 14.2056 10.1429 14.1696C10.2989 14.1336 10.4459 14.0766 10.5839 13.9986C10.7279 13.9206 10.8599 13.8216 10.9799 13.7016C11.0999 13.5756 11.1959 13.4256 11.2679 13.2516L12.2849 13.8366C12.1829 14.0766 12.0359 14.2896 11.8439 14.4756C11.6579 14.6556 11.4449 14.8086 11.2049 14.9346C10.9709 15.0606 10.7189 15.1566 10.4489 15.2226C10.1789 15.2886 9.91493 15.3216 9.65693 15.3216C9.20093 15.3216 8.78393 15.2256 8.40593 15.0336C8.02793 14.8416 7.70093 14.5926 7.42493 14.2866C7.15493 13.9746 6.94193 13.6236 6.78593 13.2336C6.63593 12.8376 6.56093 12.4356 6.56093 12.0276ZM15.9333 15.3126C15.4653 15.3126 15.0393 15.2226 14.6553 15.0426C14.2773 14.8566 13.9503 14.6136 13.6743 14.3136C13.4043 14.0076 13.1943 13.6596 13.0443 13.2696C12.8943 12.8796 12.8193 12.4806 12.8193 12.0726C12.8193 11.6466 12.8973 11.2386 13.0533 10.8486C13.2153 10.4586 13.4343 10.1136 13.7103 9.81358C13.9923 9.51358 14.3253 9.27658 14.7093 9.10258C15.0933 8.92258 15.5103 8.83258 15.9603 8.83258C16.4223 8.83258 16.8423 8.92858 17.2203 9.12058C17.6043 9.30658 17.9313 9.55258 18.2013 9.85858C18.4713 10.1646 18.6813 10.5126 18.8313 10.9026C18.9813 11.2926 19.0563 11.6886 19.0563 12.0906C19.0563 12.5166 18.9783 12.9246 18.8223 13.3146C18.6663 13.6986 18.4503 14.0406 18.1743 14.3406C17.8983 14.6346 17.5683 14.8716 17.1843 15.0516C16.8003 15.2256 16.3833 15.3126 15.9333 15.3126ZM14.0793 12.0726C14.0793 12.3486 14.1213 12.6156 14.2053 12.8736C14.2893 13.1316 14.4093 13.3596 14.5653 13.5576C14.7273 13.7556 14.9223 13.9146 15.1503 14.0346C15.3843 14.1546 15.6483 14.2146 15.9423 14.2146C16.2423 14.2146 16.5063 14.1546 16.7343 14.0346C16.9683 13.9086 17.1633 13.7436 17.3193 13.5396C17.4813 13.3356 17.6013 13.1076 17.6793 12.8556C17.7633 12.5976 17.8053 12.3366 17.8053 12.0726C17.8053 11.7966 17.7603 11.5296 17.6703 11.2716C17.5863 11.0136 17.4633 10.7856 17.3013 10.5876C17.1453 10.3896 16.9503 10.2336 16.7163 10.1196C16.4883 9.99958 16.2303 9.93958 15.9423 9.93958C15.6423 9.93958 15.3753 10.0026 15.1413 10.1286C14.9073 10.2486 14.7123 10.4106 14.5563 10.6146C14.4003 10.8126 14.2803 11.0406 14.1963 11.2986C14.1183 11.5506 14.0793 11.8086 14.0793 12.0726Z"
        fill="#5485D3"
      />
    </SvgIconComponent>
  )
}

export function RoleInternalViewer({ size, ...props }) {
  return (
    <SvgIconComponent
      size={size}
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.6873 22.2671C18.21 22.2671 22.687 17.79 22.687 12.2673C22.687 6.74462 18.21 2.26758 12.6873 2.26758C7.16454 2.26758 2.6875 6.74462 2.6875 12.2673C2.6875 17.79 7.16454 22.2671 12.6873 22.2671Z"
        fill="#E9F7DD"
      />
      <path
        d="M8.55877 15.2676V8.87758H9.80077V15.2676H8.55877ZM12.526 11.1726V15.2676H11.284V8.87758H12.247L15.577 13.0716V8.88658H16.819V15.2676H15.811L12.526 11.1726Z"
        fill="#8DC953"
      />
    </SvgIconComponent>
  )
}

export function RoleExternalViewer({ size, ...props }) {
  return (
    <SvgIconComponent
      size={size}
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5623 22.2671C18.085 22.2671 22.562 17.79 22.562 12.2673C22.562 6.74462 18.085 2.26758 12.5623 2.26758C7.03954 2.26758 2.5625 6.74462 2.5625 12.2673C2.5625 17.79 7.03954 22.2671 12.5623 22.2671Z"
        fill="#CCF6F4"
      />
      <path
        d="M11.9787 14.1786V15.2676H7.54168V8.87758H11.8977V9.96658H8.78368V11.5056H11.4747V12.5136H8.78368V14.1786H11.9787ZM13.754 8.87758L15.347 11.2536L16.931 8.87758H18.272L15.995 12.1176L18.2 15.2676H16.859L15.347 12.9816L13.826 15.2676H12.476L14.681 12.1176L12.404 8.87758H13.754Z"
        fill="#00C8BD"
      />
    </SvgIconComponent>
  )
}

export function RoleSubcontractor({ size, ...props }) {
  return (
    <SvgIconComponent
      size={size}
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4373 22.2671C17.96 22.2671 22.437 17.79 22.437 12.2673C22.437 6.74462 17.96 2.26758 12.4373 2.26758C6.91454 2.26758 2.4375 6.74462 2.4375 12.2673C2.4375 17.79 6.91454 22.2671 12.4373 22.2671Z"
        fill="#F8F1E5"
      />
      <path
        d="M10.2007 10.5516C10.1587 10.5096 10.0807 10.4526 9.96673 10.3806C9.85873 10.3086 9.72373 10.2396 9.56173 10.1736C9.40573 10.1016 9.23473 10.0416 9.04873 9.99358C8.86273 9.94558 8.67373 9.92158 8.48173 9.92158C8.13973 9.92158 7.88473 9.98458 7.71673 10.1106C7.54873 10.2366 7.46473 10.4136 7.46473 10.6416C7.46473 10.7736 7.49473 10.8846 7.55473 10.9746C7.62073 11.0586 7.71373 11.1336 7.83373 11.1996C7.95373 11.2656 8.10373 11.3256 8.28373 11.3796C8.46973 11.4336 8.68273 11.4906 8.92273 11.5506C9.23473 11.6346 9.51673 11.7246 9.76873 11.8206C10.0267 11.9166 10.2427 12.0366 10.4167 12.1806C10.5967 12.3246 10.7347 12.4986 10.8307 12.7026C10.9267 12.9006 10.9747 13.1466 10.9747 13.4406C10.9747 13.7826 10.9087 14.0766 10.7767 14.3226C10.6507 14.5626 10.4767 14.7576 10.2547 14.9076C10.0387 15.0576 9.78673 15.1686 9.49873 15.2406C9.21673 15.3066 8.91973 15.3396 8.60773 15.3396C8.12773 15.3396 7.65373 15.2676 7.18573 15.1236C6.71773 14.9796 6.29773 14.7756 5.92573 14.5116L6.47473 13.4406C6.52873 13.4946 6.62473 13.5666 6.76273 13.6566C6.90673 13.7406 7.07473 13.8276 7.26673 13.9176C7.45873 14.0016 7.67173 14.0736 7.90573 14.1336C8.13973 14.1936 8.37973 14.2236 8.62573 14.2236C9.30973 14.2236 9.65173 14.0046 9.65173 13.5666C9.65173 13.4286 9.61273 13.3116 9.53473 13.2156C9.45673 13.1196 9.34573 13.0356 9.20173 12.9636C9.05773 12.8916 8.88373 12.8256 8.67973 12.7656C8.47573 12.7056 8.24773 12.6396 7.99573 12.5676C7.68973 12.4836 7.42273 12.3936 7.19473 12.2976C6.97273 12.1956 6.78673 12.0786 6.63673 11.9466C6.48673 11.8086 6.37273 11.6526 6.29473 11.4786C6.22273 11.2986 6.18673 11.0856 6.18673 10.8396C6.18673 10.5156 6.24673 10.2276 6.36673 9.97558C6.48673 9.72358 6.65173 9.51358 6.86173 9.34558C7.07773 9.17758 7.32673 9.05158 7.60873 8.96758C7.89073 8.87758 8.19373 8.83258 8.51773 8.83258C8.96773 8.83258 9.38173 8.90458 9.75973 9.04858C10.1377 9.18658 10.4677 9.35158 10.7497 9.54358L10.2007 10.5516ZM14.7633 14.2146C15.0573 14.2146 15.3033 14.1546 15.5013 14.0346C15.7053 13.9146 15.8673 13.7586 15.9873 13.5666C16.1133 13.3746 16.2003 13.1556 16.2483 12.9096C16.3023 12.6576 16.3293 12.3996 16.3293 12.1356V8.87758H17.5623V12.1356C17.5623 12.5736 17.5083 12.9846 17.4003 13.3686C17.2983 13.7526 17.1333 14.0886 16.9053 14.3766C16.6833 14.6646 16.3953 14.8926 16.0413 15.0606C15.6873 15.2286 15.2643 15.3126 14.7723 15.3126C14.2623 15.3126 13.8273 15.2256 13.4673 15.0516C13.1133 14.8716 12.8253 14.6376 12.6033 14.3496C12.3813 14.0556 12.2193 13.7166 12.1173 13.3326C12.0213 12.9486 11.9733 12.5496 11.9733 12.1356V8.87758H13.2153V12.1356C13.2153 12.4056 13.2393 12.6666 13.2873 12.9186C13.3413 13.1646 13.4283 13.3836 13.5483 13.5756C13.6743 13.7676 13.8363 13.9236 14.0343 14.0436C14.2323 14.1576 14.4753 14.2146 14.7633 14.2146Z"
        fill="#CCA77A"
      />
    </SvgIconComponent>
  )
}

export function TeamPlainDefault({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      {...props}
      size={size}
    >
      <path
        d="M15.2895 15.282C17.85 15.282 19.9256 13.2042 19.9256 10.641C19.9256 8.07785 17.85 6 15.2895 6C12.729 6 10.6533 8.07785 10.6533 10.641C10.6533 13.2042 12.729 15.282 15.2895 15.282Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99184 28.4999H6.01785C5.89021 26.2032 6.44948 23.9206 7.62383 21.9435C8.79818 19.9664 10.5345 18.3845 12.6112 17.3999C13.4386 17.8343 14.3587 18.0613 15.2931 18.0613C16.2274 18.0613 17.1479 17.8343 17.9753 17.3999C18.2723 17.5153 18.5626 17.6475 18.8445 17.7959"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7088 15.282C35.2692 15.282 37.3449 13.2042 37.3449 10.641C37.3449 8.07785 35.2692 6 32.7088 6C30.1483 6 28.0726 8.07785 28.0726 10.641C28.0726 13.2042 30.1483 15.282 32.7088 15.282Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.0081 28.4994H41.9821C42.1098 26.2027 41.5505 23.9201 40.3762 21.943C39.2018 19.9659 37.4654 18.3841 35.3888 17.3994C34.5614 17.8338 33.6409 18.0608 32.7066 18.0608C31.7722 18.0608 30.8521 17.8338 30.0247 17.3994C29.7277 17.5148 29.4374 17.647 29.1555 17.7954"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3038 28.689C27.149 28.689 29.4555 26.3801 29.4555 23.532C29.4555 20.6839 27.149 18.375 24.3038 18.375C21.4587 18.375 19.1522 20.6839 19.1522 23.532C19.1522 26.3801 21.4587 28.689 24.3038 28.689Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0029 41.9999C13.863 39.566 14.4961 37.1502 15.8112 35.0982C17.1262 33.0462 19.0558 31.4633 21.3242 30.5759L21.3633 30.5939C21.7884 30.8111 22.2353 30.9822 22.6968 31.1039C22.7417 31.1039 22.7957 31.1219 22.8376 31.1369C23.0226 31.1802 23.2097 31.2143 23.3981 31.2389L23.5839 31.2659C23.8237 31.2937 24.0647 31.3087 24.3061 31.3109C24.5425 31.3086 24.7784 31.2936 25.0132 31.2659L25.1873 31.2479C25.4134 31.2177 25.6375 31.1746 25.8586 31.1189C26.0774 31.0589 26.2959 30.9899 26.5087 30.9119L26.6708 30.8549C26.8506 30.7769 27.0303 30.6989 27.2042 30.6089C27.2221 30.6089 27.2489 30.5909 27.2759 30.5759C29.5442 31.4633 31.4742 33.0462 32.7893 35.0982C34.1043 37.1502 34.737 39.566 34.5972 41.9999"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function TeamPlainInvited({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M15.2895 15.282C17.85 15.282 19.9257 13.2042 19.9257 10.641C19.9257 8.07785 17.85 6 15.2895 6C12.729 6 10.6534 8.07785 10.6534 10.641C10.6534 13.2042 12.729 15.282 15.2895 15.282Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99184 28.4999H6.01785C5.89021 26.2032 6.44948 23.9206 7.62383 21.9435C8.79818 19.9664 10.5345 18.3845 12.6112 17.3999C13.4386 17.8343 14.3587 18.0613 15.2931 18.0613C16.2274 18.0613 17.1479 17.8343 17.9753 17.3999C18.2723 17.5153 18.5626 17.6475 18.8445 17.7959"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7088 15.282C35.2692 15.282 37.3449 13.2042 37.3449 10.641C37.3449 8.07785 35.2692 6 32.7088 6C30.1483 6 28.0726 8.07785 28.0726 10.641C28.0726 13.2042 30.1483 15.282 32.7088 15.282Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.0081 28.4994H41.9821C42.1098 26.2027 41.5505 23.9201 40.3762 21.943C39.2018 19.9659 37.4654 18.3841 35.3888 17.3994C34.5614 17.8338 33.6409 18.0608 32.7066 18.0608C31.7722 18.0608 30.8521 17.8338 30.0247 17.3994C29.7277 17.5148 29.4374 17.647 29.1555 17.7954"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3039 28.689C27.149 28.689 29.4555 26.3801 29.4555 23.532C29.4555 20.6839 27.149 18.375 24.3039 18.375C21.4587 18.375 19.1523 20.6839 19.1523 23.532C19.1523 26.3801 21.4587 28.689 24.3039 28.689Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0029 41.9999C13.8631 39.566 14.4961 37.1502 15.8112 35.0982C17.1263 33.0462 19.0559 31.4633 21.3242 30.5759L21.3634 30.5939C21.7884 30.8111 22.2353 30.9822 22.6968 31.1039C22.7418 31.1039 22.7957 31.1219 22.8377 31.1369C23.0226 31.1802 23.2097 31.2143 23.3981 31.2389L23.584 31.2659C23.8237 31.2937 24.0647 31.3087 24.3061 31.3109C24.5425 31.3086 24.7785 31.2936 25.0132 31.2659L25.1874 31.2479C25.4134 31.2177 25.6375 31.1746 25.8587 31.1189C26.0774 31.0589 26.296 30.9899 26.5088 30.9119L26.6708 30.8549C26.8506 30.7769 27.0304 30.6989 27.2042 30.6089C27.2222 30.6089 27.2489 30.5909 27.2759 30.5759C27.6725 30.7311 28.0587 30.9075 28.4331 31.1039"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#4D8CE8"
      />
    </SvgIconComponent>
  )
}

export function TeamPlainActive({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#141A21"
      {...props}
      size={size}
    >
      <path
        d="M15.2895 15.282C17.85 15.282 19.9256 13.2042 19.9256 10.641C19.9256 8.07785 17.85 6 15.2895 6C12.729 6 10.6533 8.07785 10.6533 10.641C10.6533 13.2042 12.729 15.282 15.2895 15.282Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99184 28.4999H6.01785C5.89021 26.2032 6.44948 23.9206 7.62383 21.9435C8.79818 19.9664 10.5345 18.3845 12.6112 17.3999C13.4386 17.8343 14.3587 18.0613 15.2931 18.0613C16.2274 18.0613 17.1479 17.8343 17.9753 17.3999C18.2723 17.5153 18.5626 17.6475 18.8445 17.7959"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7088 15.282C35.2693 15.282 37.3449 13.2042 37.3449 10.641C37.3449 8.07785 35.2693 6 32.7088 6C30.1483 6 28.0726 8.07785 28.0726 10.641C28.0726 13.2042 30.1483 15.282 32.7088 15.282Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.0081 28.4994H41.9821C42.1098 26.2027 41.5505 23.9201 40.3762 21.943C39.2018 19.9659 37.4654 18.3841 35.3888 17.3994C34.5614 17.8338 33.6409 18.0608 32.7066 18.0608C31.7722 18.0608 30.8521 17.8338 30.0247 17.3994C29.7277 17.5148 29.4374 17.647 29.1555 17.7954"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3039 28.689C27.1491 28.689 29.4555 26.3801 29.4555 23.532C29.4555 20.6839 27.1491 18.375 24.3039 18.375C21.4587 18.375 19.1523 20.6839 19.1523 23.532C19.1523 26.3801 21.4587 28.689 24.3039 28.689Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0029 41.9999C13.863 39.566 14.4961 37.1502 15.8112 35.0982C17.1262 33.0462 19.0558 31.4633 21.3242 30.5759L21.3633 30.5939C21.7884 30.8111 22.2353 30.9822 22.6968 31.1039C22.7417 31.1039 22.7957 31.1219 22.8376 31.1369C23.0226 31.1802 23.2097 31.2143 23.3981 31.2389L23.5839 31.2659C23.8237 31.2937 24.0647 31.3087 24.3061 31.3109C24.5425 31.3086 24.7784 31.2936 25.0132 31.2659L25.1873 31.2479C25.4134 31.2177 25.6375 31.1746 25.8586 31.1189C26.0774 31.0589 26.2959 30.9899 26.5087 30.9119L26.6708 30.8549C26.8506 30.7769 27.0303 30.6989 27.2042 30.6089C27.2221 30.6089 27.2489 30.5909 27.2759 30.5759C27.6725 30.7311 28.0587 30.9075 28.4331 31.1039"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#91D656"
      />
    </SvgIconComponent>
  )
}

export function TeamPlainError({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M15.2895 15.282C17.85 15.282 19.9256 13.2042 19.9256 10.641C19.9256 8.07785 17.85 6 15.2895 6C12.729 6 10.6533 8.07785 10.6533 10.641C10.6533 13.2042 12.729 15.282 15.2895 15.282Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99184 28.4999H6.01785C5.89021 26.2032 6.44948 23.9206 7.62383 21.9435C8.79818 19.9664 10.5345 18.3845 12.6112 17.3999C13.4386 17.8343 14.3587 18.0613 15.2931 18.0613C16.2274 18.0613 17.1479 17.8343 17.9753 17.3999C18.2723 17.5153 18.5626 17.6475 18.8445 17.7959"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7088 15.282C35.2693 15.282 37.3449 13.2042 37.3449 10.641C37.3449 8.07785 35.2693 6 32.7088 6C30.1483 6 28.0726 8.07785 28.0726 10.641C28.0726 13.2042 30.1483 15.282 32.7088 15.282Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.0081 28.4994H41.9821C42.1098 26.2027 41.5505 23.9201 40.3762 21.943C39.2018 19.9659 37.4654 18.3841 35.3888 17.3994C34.5614 17.8338 33.6409 18.0608 32.7066 18.0608C31.7722 18.0608 30.8521 17.8338 30.0247 17.3994C29.7277 17.5148 29.4374 17.647 29.1555 17.7954"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3039 28.689C27.1491 28.689 29.4555 26.3801 29.4555 23.532C29.4555 20.6839 27.1491 18.375 24.3039 18.375C21.4587 18.375 19.1523 20.6839 19.1523 23.532C19.1523 26.3801 21.4587 28.689 24.3039 28.689Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0029 41.9999C13.863 39.566 14.4961 37.1502 15.8112 35.0982C17.1262 33.0462 19.0558 31.4633 21.3242 30.5759L21.3633 30.5939C21.7884 30.8111 22.2353 30.9822 22.6968 31.1039C22.7417 31.1039 22.7957 31.1219 22.8376 31.1369C23.0226 31.1802 23.2097 31.2143 23.3981 31.2389L23.5839 31.2659C23.8237 31.2937 24.0647 31.3087 24.3061 31.3109C24.5425 31.3086 24.7784 31.2936 25.0132 31.2659L25.1873 31.2479C25.4134 31.2177 25.6375 31.1746 25.8586 31.1189C26.0774 31.0589 26.2959 30.9899 26.5087 30.9119L26.6708 30.8549C26.8506 30.7769 27.0303 30.6989 27.2042 30.6089C27.2221 30.6089 27.2489 30.5909 27.2759 30.5759C27.6725 30.7311 28.0587 30.9075 28.4331 31.1039"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#EA4444"
      />
    </SvgIconComponent>
  )
}

export function TeamPlainInactive({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#141A21"
      {...props}
      size={size}
    >
      <path
        d="M15.2895 15.282C17.85 15.282 19.9256 13.2042 19.9256 10.641C19.9256 8.07785 17.85 6 15.2895 6C12.729 6 10.6533 8.07785 10.6533 10.641C10.6533 13.2042 12.729 15.282 15.2895 15.282Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99184 28.4999H6.01785C5.89021 26.2032 6.44948 23.9206 7.62383 21.9435C8.79818 19.9664 10.5345 18.3845 12.6112 17.3999C13.4386 17.8343 14.3587 18.0613 15.2931 18.0613C16.2274 18.0613 17.1479 17.8343 17.9753 17.3999C18.2723 17.5153 18.5626 17.6475 18.8445 17.7959"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7088 15.282C35.2693 15.282 37.3449 13.2042 37.3449 10.641C37.3449 8.07785 35.2693 6 32.7088 6C30.1483 6 28.0726 8.07785 28.0726 10.641C28.0726 13.2042 30.1483 15.282 32.7088 15.282Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.0081 28.4994H41.9821C42.1098 26.2027 41.5505 23.9201 40.3762 21.943C39.2018 19.9659 37.4654 18.3841 35.3888 17.3994C34.5614 17.8338 33.6409 18.0608 32.7066 18.0608C31.7722 18.0608 30.8521 17.8338 30.0247 17.3994C29.7277 17.5148 29.4374 17.647 29.1555 17.7954"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3039 28.689C27.1491 28.689 29.4555 26.3801 29.4555 23.532C29.4555 20.6839 27.1491 18.375 24.3039 18.375C21.4587 18.375 19.1523 20.6839 19.1523 23.532C19.1523 26.3801 21.4587 28.689 24.3039 28.689Z"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0029 41.9999C13.863 39.566 14.4961 37.1502 15.8112 35.0982C17.1262 33.0462 19.0558 31.4633 21.3242 30.5759L21.3633 30.5939C21.7884 30.8111 22.2353 30.9822 22.6968 31.1039C22.7417 31.1039 22.7957 31.1219 22.8376 31.1369C23.0226 31.1802 23.2097 31.2143 23.3981 31.2389L23.5839 31.2659C23.8237 31.2937 24.0647 31.3087 24.3061 31.3109C24.5425 31.3086 24.7784 31.2936 25.0132 31.2659L25.1873 31.2479C25.4134 31.2177 25.6375 31.1746 25.8586 31.1189C26.0774 31.0589 26.2959 30.9899 26.5087 30.9119L26.6708 30.8549C26.8506 30.7769 27.0303 30.6989 27.2042 30.6089C27.2221 30.6089 27.2489 30.5909 27.2759 30.5759C27.6725 30.7311 28.0587 30.9075 28.4331 31.1039"
        stroke="inherit"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
        fill="#BEBEC7"
      />
    </SvgIconComponent>
  )
}

export function TeamPlainCutout({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M15.2895 15.282C17.85 15.282 19.9256 13.2042 19.9256 10.641C19.9256 8.07785 17.85 6 15.2895 6C12.729 6 10.6533 8.07785 10.6533 10.641C10.6533 13.2042 12.729 15.282 15.2895 15.282Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99184 28.4999H6.01785C5.89021 26.2032 6.44948 23.9206 7.62383 21.9435C8.79818 19.9664 10.5345 18.3845 12.6112 17.3999C13.4386 17.8343 14.3587 18.0613 15.2931 18.0613C16.2274 18.0613 17.1479 17.8343 17.9753 17.3999C18.2723 17.5153 18.5626 17.6475 18.8445 17.7959"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7087 15.282C35.2692 15.282 37.3449 13.2042 37.3449 10.641C37.3449 8.07785 35.2692 6 32.7087 6C30.1482 6 28.0726 8.07785 28.0726 10.641C28.0726 13.2042 30.1482 15.282 32.7087 15.282Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.0081 28.4994H41.9821C42.1097 26.2027 41.5504 23.9201 40.3761 21.943C39.2017 19.9659 37.4654 18.3841 35.3887 17.3994C34.5613 17.8338 33.6408 18.0608 32.7065 18.0608C31.7721 18.0608 30.8521 17.8338 30.0246 17.3994C29.7276 17.5148 29.4373 17.647 29.1554 17.7954"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3038 28.689C27.149 28.689 29.4555 26.3801 29.4555 23.532C29.4555 20.6839 27.149 18.375 24.3038 18.375C21.4587 18.375 19.1522 20.6839 19.1522 23.532C19.1522 26.3801 21.4587 28.689 24.3038 28.689Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0029 41.9999C13.863 39.566 14.4961 37.1502 15.8112 35.0982C17.1262 33.0462 19.0558 31.4633 21.3242 30.5759L21.3633 30.5939C21.7884 30.8111 22.2353 30.9822 22.6968 31.1039C22.7417 31.1039 22.7957 31.1219 22.8376 31.1369C23.0226 31.1802 23.2097 31.2143 23.3981 31.2389L23.5839 31.2659C23.8237 31.2937 24.0647 31.3087 24.3061 31.3109C24.5425 31.3086 24.7784 31.2936 25.0132 31.2659L25.1873 31.2479C25.4134 31.2177 25.6375 31.1746 25.8586 31.1189C26.0774 31.0589 26.2959 30.9899 26.5087 30.9119L26.6708 30.8549C26.8506 30.7769 27.0303 30.6989 27.2042 30.6089C27.2221 30.6089 27.2489 30.5909 27.2759 30.5759C27.6725 30.7311 28.0587 30.9075 28.4331 31.1039"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function TeamEnclosedDefault({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="42"
      width="43"
      fill="none"
      viewBox="0 0 43 42"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M21.4019 41.0005C32.4476 41.0005 41.4019 32.0462 41.4019 21.0005C41.4019 9.95479 32.4476 1.00049 21.4019 1.00049C10.3562 1.00049 1.40192 9.95479 1.40192 21.0005C1.40192 32.0462 10.3562 41.0005 21.4019 41.0005Z"
        stroke={stroke ?? '#141A21'}
        strokeWidth="2"
      />
      <path
        d="M14.62 14.3938C16.2474 14.3938 17.5666 13.0746 17.5666 11.4472C17.5666 9.81976 16.2474 8.50049 14.62 8.50049C12.9926 8.50049 11.6733 9.81976 11.6733 11.4472C11.6733 13.0746 12.9926 14.3938 14.62 14.3938Z"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M11.2533 23.8605H8.72648C8.64273 22.402 8.99658 20.9519 9.74251 19.6958C10.4884 18.4397 11.5924 17.435 12.9131 16.8105C13.439 17.0868 14.024 17.2311 14.618 17.2311C15.212 17.2311 15.7974 17.0868 16.3233 16.8105C16.5125 16.883 16.6973 16.9664 16.8767 17.0605"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M28.4486 14.3938C30.076 14.3938 31.3953 13.0746 31.3953 11.4472C31.3953 9.81976 30.076 8.50049 28.4486 8.50049C26.8212 8.50049 25.502 9.81976 25.502 11.4472C25.502 13.0746 26.8212 14.3938 28.4486 14.3938Z"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M31.8167 23.8605H34.3436C34.4273 22.402 34.0735 20.9519 33.3276 19.6958C32.5816 18.4397 31.4773 17.435 30.1566 16.8105C29.6307 17.0868 29.0457 17.2311 28.4517 17.2311C27.8577 17.2311 27.2726 17.0868 26.7467 16.8105C26.5577 16.8833 26.3729 16.9668 26.1934 17.0605"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M21.5972 23.9771C23.405 23.9771 24.8705 22.5116 24.8705 20.7038C24.8705 18.896 23.405 17.4305 21.5972 17.4305C19.7894 17.4305 18.3239 18.896 18.3239 20.7038C18.3239 22.5116 19.7894 23.9771 21.5972 23.9771Z"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M15.0487 33.2672C14.9605 31.7202 15.3647 30.185 16.203 28.8819C17.0414 27.5788 18.271 26.5748 19.7154 26.0139H19.7386C20.008 26.1551 20.292 26.2669 20.5854 26.3472L20.6753 26.3671C20.793 26.3954 20.9122 26.4177 21.0321 26.4339L21.1485 26.4505C21.3002 26.4674 21.4529 26.4764 21.6055 26.4772C21.7558 26.4764 21.9061 26.4674 22.0555 26.4505H22.1654C22.309 26.4307 22.4517 26.4029 22.5922 26.3671C22.7322 26.3305 22.8685 26.2838 23.0052 26.2371L23.1086 26.2005C23.2219 26.1505 23.3389 26.1039 23.4422 26.0439L23.4854 26.0238C24.9298 26.5848 26.1593 27.5889 26.9977 28.892C27.8361 30.1951 28.2403 31.7302 28.1521 33.2771"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </SvgIconComponent>
  )
}

export function TeamEnclosedInvited({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00195 24.0005C5.00195 13.5071 13.5085 5.00049 24.002 5.00049C34.4954 5.00049 43.002 13.5071 43.002 24.0005C43.002 26.4963 42.5207 28.8797 41.646 31.063C42.1765 31.6692 42.6109 32.3615 42.9256 33.1163C44.2562 30.3592 45.002 27.267 45.002 24.0005C45.002 12.4025 35.5999 3.00049 24.002 3.00049C12.404 3.00049 3.00195 12.4025 3.00195 24.0005C3.00195 35.5985 12.404 45.0005 24.002 45.0005C27.2675 45.0005 30.359 44.2551 33.1155 42.9252C32.3607 42.6105 31.6684 42.176 31.0623 41.6454C28.8796 42.5196 26.4969 43.0005 24.002 43.0005C13.5085 43.0005 5.00195 34.4939 5.00195 24.0005Z"
        fill="#141A21"
      />
      <path
        d="M17.22 17.3938C18.8474 17.3938 20.1666 16.0746 20.1666 14.4472C20.1666 12.8198 18.8474 11.5005 17.22 11.5005C15.5926 11.5005 14.2733 12.8198 14.2733 14.4472C14.2733 16.0746 15.5926 17.3938 17.22 17.3938Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8534 26.8605H11.3265C11.2428 25.402 11.5966 23.9519 12.3425 22.6958C13.0885 21.4397 14.1924 20.435 15.5131 19.8105C16.039 20.0868 16.624 20.2311 17.218 20.2311C17.812 20.2311 18.3975 20.0868 18.9234 19.8105C19.1125 19.883 19.2973 19.9664 19.4767 20.0605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0487 17.3938C32.6761 17.3938 33.9953 16.0746 33.9953 14.4472C33.9953 12.8198 32.6761 11.5005 31.0487 11.5005C29.4213 11.5005 28.102 12.8198 28.102 14.4472C28.102 16.0746 29.4213 17.3938 31.0487 17.3938Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4168 26.8605H36.9436C37.0274 25.402 36.6735 23.9519 35.9276 22.6958C35.1817 21.4397 34.0773 20.435 32.7566 19.8105C32.2307 20.0868 31.6457 20.2311 31.0517 20.2311C30.4577 20.2311 29.8727 20.0868 29.3468 19.8105C29.1578 19.8833 28.973 19.9668 28.7934 20.0605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1972 26.9771C26.005 26.9771 27.4706 25.5116 27.4706 23.7038C27.4706 21.8959 26.005 20.4304 24.1972 20.4304C22.3894 20.4304 20.9239 21.8959 20.9239 23.7038C20.9239 25.5116 22.3894 26.9771 24.1972 26.9771Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6487 36.2672C17.5605 34.7202 17.9647 33.1851 18.803 31.882C19.6414 30.5789 20.871 29.5749 22.3154 29.0139H22.3386C22.608 29.1552 22.892 29.2669 23.1854 29.3473L23.2753 29.3672C23.393 29.3955 23.5122 29.4178 23.6321 29.4339L23.7485 29.4505C23.9002 29.4674 24.0529 29.4764 24.2055 29.4773C24.3558 29.4764 24.5061 29.4675 24.6555 29.4505H24.7654C24.909 29.4308 25.0517 29.403 25.1922 29.3672C25.3322 29.3305 25.4685 29.2839 25.6052 29.2372L25.7086 29.2006C25.8219 29.1506 25.9389 29.1039 26.0422 29.0439L26.0854 29.0239C27.5298 29.5848 28.7593 30.5889 29.5977 31.892"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={36} cy={36} r={6} fill="#4D8CE8" />
    </SvgIconComponent>
  )
}

export function TeamEnclosedActive({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00201 24.0005C5.00201 13.5071 13.5086 5.00049 24.002 5.00049C34.4954 5.00049 43.002 13.5071 43.002 24.0005C43.002 26.4963 42.5208 28.8797 41.6461 31.063C42.1766 31.6692 42.611 32.3615 42.9257 33.1163C44.2562 30.3592 45.002 27.267 45.002 24.0005C45.002 12.4025 35.6 3.00049 24.002 3.00049C12.404 3.00049 3.00201 12.4025 3.00201 24.0005C3.00201 35.5985 12.404 45.0005 24.002 45.0005C27.2676 45.0005 30.359 44.2551 33.1156 42.9252C32.3608 42.6105 31.6685 42.176 31.0624 41.6454C28.8797 42.5196 26.497 43.0005 24.002 43.0005C13.5086 43.0005 5.00201 34.4939 5.00201 24.0005Z"
        fill="#141A21"
      />
      <path
        d="M17.22 17.3938C18.8474 17.3938 20.1667 16.0746 20.1667 14.4472C20.1667 12.8198 18.8474 11.5005 17.22 11.5005C15.5926 11.5005 14.2734 12.8198 14.2734 14.4472C14.2734 16.0746 15.5926 17.3938 17.22 17.3938Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8534 26.8605H11.3266C11.2428 25.402 11.5967 23.9519 12.3426 22.6958C13.0885 21.4397 14.1925 20.435 15.5132 19.8105C16.0391 20.0868 16.6241 20.2311 17.2181 20.2311C17.8121 20.2311 18.3975 20.0868 18.9234 19.8105C19.1126 19.883 19.2974 19.9664 19.4768 20.0605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0487 17.3938C32.6761 17.3938 33.9954 16.0746 33.9954 14.4472C33.9954 12.8198 32.6761 11.5005 31.0487 11.5005C29.4213 11.5005 28.1021 12.8198 28.1021 14.4472C28.1021 16.0746 29.4213 17.3938 31.0487 17.3938Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4168 26.8605H36.9437C37.0274 25.402 36.6736 23.9519 35.9277 22.6958C35.1817 21.4397 34.0774 20.435 32.7567 19.8105C32.2308 20.0868 31.6458 20.2311 31.0518 20.2311C30.4578 20.2311 29.8727 20.0868 29.3468 19.8105C29.1578 19.8833 28.973 19.9668 28.7935 20.0605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1973 26.9771C26.0051 26.9771 27.4706 25.5116 27.4706 23.7038C27.4706 21.8959 26.0051 20.4304 24.1973 20.4304C22.3895 20.4304 20.924 21.8959 20.924 23.7038C20.924 25.5116 22.3895 26.9771 24.1973 26.9771Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6487 36.2672C17.5605 34.7202 17.9647 33.1851 18.8031 31.882C19.6415 30.5789 20.8711 29.5749 22.3155 29.0139H22.3387C22.6081 29.1552 22.892 29.2669 23.1854 29.3473L23.2754 29.3672C23.393 29.3955 23.5123 29.4178 23.6322 29.4339L23.7486 29.4505C23.9002 29.4674 24.0529 29.4764 24.2055 29.4773C24.3559 29.4764 24.5062 29.4675 24.6556 29.4505H24.7654C24.9091 29.4308 25.0517 29.403 25.1923 29.3672C25.3323 29.3305 25.4686 29.2839 25.6053 29.2372L25.7086 29.2006C25.822 29.1506 25.939 29.1039 26.0423 29.0439L26.0854 29.0239C27.5298 29.5848 28.7594 30.5889 29.5978 31.892"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={36} cy={36} r={6} fill="#91D656" />
    </SvgIconComponent>
  )
}

export function TeamEnclosedError({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00195 24.0005C5.00195 13.5071 13.5085 5.00049 24.002 5.00049C34.4954 5.00049 43.002 13.5071 43.002 24.0005C43.002 26.4963 42.5207 28.8797 41.646 31.063C42.1765 31.6692 42.6109 32.3615 42.9256 33.1163C44.2562 30.3592 45.002 27.267 45.002 24.0005C45.002 12.4025 35.5999 3.00049 24.002 3.00049C12.404 3.00049 3.00195 12.4025 3.00195 24.0005C3.00195 35.5985 12.404 45.0005 24.002 45.0005C27.2675 45.0005 30.359 44.2551 33.1155 42.9252C32.3607 42.6105 31.6684 42.176 31.0623 41.6454C28.8796 42.5196 26.4969 43.0005 24.002 43.0005C13.5085 43.0005 5.00195 34.4939 5.00195 24.0005Z"
        fill="#141A21"
      />
      <path
        d="M17.22 17.3938C18.8474 17.3938 20.1666 16.0746 20.1666 14.4472C20.1666 12.8198 18.8474 11.5005 17.22 11.5005C15.5926 11.5005 14.2733 12.8198 14.2733 14.4472C14.2733 16.0746 15.5926 17.3938 17.22 17.3938Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8533 26.8605H11.3265C11.2427 25.402 11.5966 23.9519 12.3425 22.6958C13.0884 21.4397 14.1924 20.435 15.5131 19.8105C16.0389 20.0868 16.624 20.2311 17.218 20.2311C17.812 20.2311 18.3974 20.0868 18.9233 19.8105C19.1125 19.883 19.2973 19.9664 19.4767 20.0605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0486 17.3938C32.676 17.3938 33.9953 16.0746 33.9953 14.4472C33.9953 12.8198 32.676 11.5005 31.0486 11.5005C29.4212 11.5005 28.1019 12.8198 28.1019 14.4472C28.1019 16.0746 29.4212 17.3938 31.0486 17.3938Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4167 26.8605H36.9436C37.0273 25.402 36.6735 23.9519 35.9275 22.6958C35.1816 21.4397 34.0772 20.435 32.7566 19.8105C32.2307 20.0868 31.6456 20.2311 31.0516 20.2311C30.4576 20.2311 29.8726 20.0868 29.3467 19.8105C29.1577 19.8833 28.9729 19.9668 28.7933 20.0605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1972 26.9771C26.005 26.9771 27.4705 25.5116 27.4705 23.7038C27.4705 21.8959 26.005 20.4304 24.1972 20.4304C22.3893 20.4304 20.9238 21.8959 20.9238 23.7038C20.9238 25.5116 22.3893 26.9771 24.1972 26.9771Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6486 36.2672C17.5604 34.7202 17.9646 33.1851 18.803 31.882C19.6414 30.5789 20.871 29.5749 22.3154 29.0139H22.3386C22.608 29.1552 22.8919 29.2669 23.1853 29.3473L23.2752 29.3672C23.3929 29.3955 23.5121 29.4178 23.6321 29.4339L23.7485 29.4505C23.9001 29.4674 24.0528 29.4764 24.2054 29.4773C24.3558 29.4764 24.506 29.4675 24.6554 29.4505H24.7653C24.909 29.4308 25.0516 29.403 25.1921 29.3672C25.3321 29.3305 25.4685 29.2839 25.6052 29.2372L25.7085 29.2006C25.8218 29.1506 25.9388 29.1039 26.0422 29.0439L26.0853 29.0239C27.5297 29.5848 28.7593 30.5889 29.5977 31.892"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={36} cy={36} r={6} fill="#EA4444" />
    </SvgIconComponent>
  )
}

export function TeamEnclosedInactive({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00195 24.0005C5.00195 13.5071 13.5085 5.00049 24.0019 5.00049C34.4954 5.00049 43.0019 13.5071 43.0019 24.0005C43.0019 26.4963 42.5207 28.8797 41.646 31.063C42.1765 31.6692 42.6109 32.3615 42.9256 33.1163C44.2562 30.3592 45.0019 27.267 45.0019 24.0005C45.0019 12.4025 35.5999 3.00049 24.0019 3.00049C12.404 3.00049 3.00195 12.4025 3.00195 24.0005C3.00195 35.5985 12.404 45.0005 24.0019 45.0005C27.2675 45.0005 30.359 44.2551 33.1155 42.9252C32.3607 42.6105 31.6684 42.176 31.0623 41.6454C28.8796 42.5196 26.4969 43.0005 24.0019 43.0005C13.5085 43.0005 5.00195 34.4939 5.00195 24.0005Z"
        fill="#141A21"
      />
      <path
        d="M17.22 17.3938C18.8474 17.3938 20.1666 16.0746 20.1666 14.4472C20.1666 12.8198 18.8474 11.5005 17.22 11.5005C15.5926 11.5005 14.2733 12.8198 14.2733 14.4472C14.2733 16.0746 15.5926 17.3938 17.22 17.3938Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8534 26.8605H11.3265C11.2428 25.402 11.5966 23.9519 12.3425 22.6958C13.0885 21.4397 14.1924 20.435 15.5131 19.8105C16.039 20.0868 16.624 20.2311 17.218 20.2311C17.812 20.2311 18.3975 20.0868 18.9234 19.8105C19.1125 19.883 19.2973 19.9664 19.4767 20.0605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0487 17.3938C32.6761 17.3938 33.9954 16.0746 33.9954 14.4472C33.9954 12.8198 32.6761 11.5005 31.0487 11.5005C29.4213 11.5005 28.1021 12.8198 28.1021 14.4472C28.1021 16.0746 29.4213 17.3938 31.0487 17.3938Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4168 26.8605H36.9437C37.0274 25.402 36.6736 23.9519 35.9277 22.6958C35.1817 21.4397 34.0774 20.435 32.7567 19.8105C32.2308 20.0868 31.6458 20.2311 31.0518 20.2311C30.4578 20.2311 29.8727 20.0868 29.3468 19.8105C29.1578 19.8833 28.973 19.9668 28.7935 20.0605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1973 26.9771C26.0051 26.9771 27.4706 25.5116 27.4706 23.7038C27.4706 21.8959 26.0051 20.4304 24.1973 20.4304C22.3895 20.4304 20.924 21.8959 20.924 23.7038C20.924 25.5116 22.3895 26.9771 24.1973 26.9771Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6487 36.2672C17.5605 34.7202 17.9647 33.1851 18.8031 31.882C19.6415 30.5789 20.8711 29.5749 22.3155 29.0139H22.3387C22.6081 29.1552 22.892 29.2669 23.1854 29.3473L23.2754 29.3672C23.393 29.3955 23.5123 29.4178 23.6322 29.4339L23.7486 29.4505C23.9002 29.4674 24.0529 29.4764 24.2055 29.4773C24.3559 29.4764 24.5062 29.4675 24.6556 29.4505H24.7654C24.9091 29.4308 25.0517 29.403 25.1923 29.3672C25.3323 29.3305 25.4686 29.2839 25.6053 29.2372L25.7086 29.2006C25.822 29.1506 25.939 29.1039 26.0423 29.0439L26.0854 29.0239C27.5298 29.5848 28.7594 30.5889 29.5978 31.892"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={36} cy={36} r={6} fill="#BEBEC7" />
    </SvgIconComponent>
  )
}

export function TeamEnclosedCutout({ size, ...props }) {
  return (
    <SvgIconComponent
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00196 24.0005C5.00196 13.5071 13.5085 5.00049 24.002 5.00049C34.4954 5.00049 43.002 13.5071 43.002 24.0005C43.002 26.4963 42.5207 28.8797 41.646 31.063C42.1765 31.6692 42.611 32.3615 42.9256 33.1163C44.2562 30.3592 45.002 27.267 45.002 24.0005C45.002 12.4025 35.5999 3.00049 24.002 3.00049C12.404 3.00049 3.00196 12.4025 3.00196 24.0005C3.00196 35.5985 12.404 45.0005 24.002 45.0005C27.2675 45.0005 30.359 44.2551 33.1155 42.9252C32.3607 42.6105 31.6684 42.176 31.0623 41.6454C28.8796 42.5196 26.4969 43.0005 24.002 43.0005C13.5085 43.0005 5.00196 34.4939 5.00196 24.0005Z"
        fill="#141A21"
      />
      <path
        d="M17.22 17.3938C18.8474 17.3938 20.1666 16.0746 20.1666 14.4472C20.1666 12.8198 18.8474 11.5005 17.22 11.5005C15.5926 11.5005 14.2733 12.8198 14.2733 14.4472C14.2733 16.0746 15.5926 17.3938 17.22 17.3938Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8534 26.8605H11.3265C11.2428 25.402 11.5966 23.9519 12.3425 22.6958C13.0885 21.4397 14.1924 20.435 15.5131 19.8105C16.039 20.0868 16.624 20.2311 17.218 20.2311C17.812 20.2311 18.3975 20.0868 18.9234 19.8105C19.1125 19.883 19.2973 19.9664 19.4767 20.0605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0487 17.3938C32.6761 17.3938 33.9954 16.0746 33.9954 14.4472C33.9954 12.8198 32.6761 11.5005 31.0487 11.5005C29.4213 11.5005 28.1021 12.8198 28.1021 14.4472C28.1021 16.0746 29.4213 17.3938 31.0487 17.3938Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4168 26.8605H36.9437C37.0274 25.402 36.6736 23.9519 35.9277 22.6958C35.1817 21.4397 34.0774 20.435 32.7567 19.8105C32.2308 20.0868 31.6458 20.2311 31.0518 20.2311C30.4578 20.2311 29.8727 20.0868 29.3468 19.8105C29.1578 19.8833 28.973 19.9668 28.7935 20.0605"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1973 26.9771C26.0051 26.9771 27.4706 25.5116 27.4706 23.7038C27.4706 21.8959 26.0051 20.4304 24.1973 20.4304C22.3895 20.4304 20.924 21.8959 20.924 23.7038C20.924 25.5116 22.3895 26.9771 24.1973 26.9771Z"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6487 36.2672C17.5605 34.7202 17.9647 33.1851 18.8031 31.882C19.6415 30.5789 20.8711 29.5749 22.3155 29.0139H22.3387C22.6081 29.1552 22.892 29.2669 23.1854 29.3473L23.2754 29.3672C23.393 29.3955 23.5123 29.4178 23.6322 29.4339L23.7486 29.4505C23.9002 29.4674 24.0529 29.4764 24.2055 29.4773C24.3559 29.4764 24.5062 29.4675 24.6556 29.4505H24.7654C24.9091 29.4308 25.0517 29.403 25.1923 29.3672C25.3323 29.3305 25.4686 29.2839 25.6053 29.2372L25.7086 29.2006C25.822 29.1506 25.939 29.1039 26.0423 29.0439L26.0854 29.0239C27.5298 29.5848 28.7594 30.5889 29.5978 31.892"
        stroke="#141A21"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes))
}

Assignee.propTypes = iconPropTypes
ContactEnclosed.propTypes = iconPropTypes
ContactPlain.propTypes = iconPropTypes
Mail.propTypes = iconPropTypes
MemberPlainDefault.propTypes = iconPropTypes
MemberPlainInvited.propTypes = iconPropTypes
MemberPlainActive.propTypes = iconPropTypes
MemberPlainError.propTypes = iconPropTypes
MemberPlainInactive.propTypes = iconPropTypes
MemberPlainCutout.propTypes = iconPropTypes
MemberEnclosedDefault.propTypes = iconPropTypes
MemberEnclosedInvited.propTypes = iconPropTypes
MemberEnclosedActive.propTypes = iconPropTypes
MemberEnclosedError.propTypes = iconPropTypes
MemberEnclosedInactive.propTypes = iconPropTypes
MemberEnclosedCutout.propTypes = iconPropTypes
Phone.propTypes = iconPropTypes
RoleAdministrator.propTypes = iconPropTypes
RoleCotributor.propTypes = iconPropTypes
RoleInternalViewer.propTypes = iconPropTypes
RoleExternalViewer.propTypes = iconPropTypes
RoleSubcontractor.propTypes = iconPropTypes
TeamPlainDefault.propTypes = iconPropTypes
TeamPlainInvited.propTypes = iconPropTypes
TeamPlainActive.propTypes = iconPropTypes
TeamPlainError.propTypes = iconPropTypes
TeamPlainInactive.propTypes = iconPropTypes
TeamPlainCutout.propTypes = iconPropTypes
TeamEnclosedDefault.propTypes = iconPropTypes
TeamEnclosedInvited.propTypes = iconPropTypes
TeamEnclosedActive.propTypes = iconPropTypes
TeamEnclosedError.propTypes = iconPropTypes
TeamEnclosedInactive.propTypes = iconPropTypes
TeamEnclosedCutout.propTypes = iconPropTypes

const iconsUsers = {
  Assignee,
  ContactEnclosed,
  ContactPlain,
  Mail,
  MemberPlainDefault,
  MemberPlainInvited,
  MemberPlainActive,
  MemberPlainError,
  MemberPlainInactive,
  MemberPlainCutout,
  MemberEnclosedDefault,
  MemberEnclosedInvited,
  MemberEnclosedActive,
  MemberEnclosedError,
  MemberEnclosedInactive,
  MemberEnclosedCutout,
  Phone,
  RoleAdministrator,
  RoleCotributor,
  RoleInternalViewer,
  RoleExternalViewer,
  RoleSubcontractor,
  TeamPlainDefault,
  TeamPlainInvited,
  TeamPlainActive,
  TeamPlainError,
  TeamPlainInactive,
  TeamPlainCutout,
  TeamEnclosedDefault,
  TeamEnclosedInvited,
  TeamEnclosedActive,
  TeamEnclosedError,
  TeamEnclosedInactive,
  TeamEnclosedCutout
}

export default iconsUsers
